export default __webpack_public_path__ + "static/media/hs1.4bfb14ee.png";